export default __webpack_public_path__ + "static/media/working-forms-1x.5041e22e.png";